import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, unref as _unref, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18e68c2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col justify-start gap-y-3 py-4 text-left text-textPrimary" }
const _hoisted_2 = { class: "border-0 p-0 m-0" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "font-semibold text-textPrimary mb-3 block" }, "Formato de exportação", -1))
const _hoisted_4 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "format-card__radio" }, null, -1))
const _hoisted_8 = { class: "format-card__content" }
const _hoisted_9 = { class: "format-card__label" }
const _hoisted_10 = { class: "format-card__desc" }
const _hoisted_11 = {
  key: 0,
  class: "border-0 p-0 m-0"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "font-semibold text-textPrimary mb-1 block" }, "Nomear os arquivos por", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50 mb-2" }, " Arraste, ou use as setas ↑ e ↓, para mudar a ordem das partes do nome. ", -1))
const _hoisted_14 = {
  role: "list",
  class: "flex flex-col gap-1 m-0 p-0 list-none"
}
const _hoisted_15 = ["data-testid", "onDragstart", "onDrop", "onKeydown"]
const _hoisted_16 = { class: "flex items-center gap-2 cursor-pointer flex-1" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "text-sm" }
const _hoisted_19 = { class: "flex items-center gap-1" }
const _hoisted_20 = ["data-testid", "aria-disabled", "aria-label", "onClick"]
const _hoisted_21 = ["data-testid", "aria-disabled", "aria-label", "onClick"]
const _hoisted_22 = {
  "data-testid": "export-name-preview",
  "aria-live": "polite",
  class: "mt-2 rounded bg-gray-100 px-3 py-2 font-mono text-xs text-textPrimary break-all"
}
const _hoisted_23 = { class: "flex items-center mb-3 w-full gap-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", {
  id: "export-filters-title",
  class: "font-semibold text-textPrimary"
}, " Filtros aplicados (somente leitura) ", -1))
const _hoisted_25 = {
  key: 0,
  role: "list",
  "aria-labelledby": "export-filters-title",
  class: "flex w-full flex-wrap gap-1.5"
}
const _hoisted_26 = { class: "font-normal" }
const _hoisted_27 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mt-2 text-xs text-gray-500",
  "data-testid": "export-filters-caveat"
}, " O período acima substitui o filtro 'Data do plantão' da fila. Todos os demais filtros da fila (status, unidade, escala, turno, tipo, marcadores, motivo da revisão e data de upload) são aplicados ao arquivo. ", -1))
const _hoisted_29 = {
  key: 1,
  "data-testid": "export-blocked-hint",
  role: "status",
  class: "rounded border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-800"
}
const _hoisted_30 = { class: "grid grid-cols-2 gap-x-4 w-full" }
const _hoisted_31 = {
  key: 2,
  "aria-live": "polite",
  class: "text-sm text-gray-500"
}
const _hoisted_32 = {
  key: 3,
  "data-testid": "export-attachments-estimate",
  "aria-live": "polite",
  class: "text-sm text-gray-600"
}
const _hoisted_33 = {
  key: 4,
  "data-testid": "export-attachments-error",
  role: "alert",
  class: "rounded border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700"
}
const _hoisted_34 = { class: "flex items-center justify-between w-full mt-2" }

import { ref, computed, watch, onBeforeUnmount } from 'vue'
import { format } from 'date-fns'
import { mdiCalendarBlankOutline, mdiFilterOutline } from '@mdi/js'
import { DatePicker } from 'v-calendar'
import 'v-calendar/style.css'
import type { DSAttendanceExportContainersParams } from '@/Network/Types/Requests/DsAttendanceRequest'
import type { ListContainersByCompanyParams } from '@/types/ds-attendance.types'
import Network from '@/Network'
import type {
  DSAttendanceAttachmentExportEstimate,
  DSAttendanceAttachmentExportParams
} from '@/Network/Services/DsAttendanceService'
import {
  ATTACHMENT_EXPORT_FORMATS,
  ATTACHMENT_EXPORT_FORMAT_LABELS,
  DEFAULT_EXPORT_NAME_PARTS,
  EXPORT_NAME_PART_LABELS,
  EXPORT_TOO_LARGE,
  ExportNamePart,
  type AttachmentExportFormat
} from '@/constants/ds-attendance.constants'
import { parseLocalDate } from '@/utils/date'
import { useErrorToast } from '@/composables/useErrorToast'
import {
  getApiErrorMessage,
  getApiErrorStatus,
  hasApiErrorCode,
  unwrapApiError
} from '@/utils/apiError'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import {
  resolveBlockReason,
  toExportCut,
  type ExportModalMode
} from '@/components/designSystem/modals/exportDsAttendances.utils'
import Tabs, { type TabItem } from '@/components/designSystem/Tabs/Tabs.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

const ESTIMATE_DEBOUNCE_MS = 400

/** Aba pedida pelo pai, corrigida para uma que o usuário de fato recebe. */
const modalTitle = 'Exportar registro'

const NAME_PREVIEW_SUFFIX = '_reg55_01.jpg'

/**
 * Lista vazia cai no default das quatro partes, igual ao backend
 * (`DEFAULT_ACTIVITY_EXPORT_NAME`): sem isso o preview ficaria só o sufixo e o
 * usuário acharia que exportaria arquivo sem nome.
 */
const DEFAULT_ERROR_MESSAGE = 'Não foi possível exportar os registros. Tente novamente.'
const DEFAULT_ATTACHMENT_ERROR_MESSAGE = 'Não foi possível exportar os anexos. Tente novamente.'

interface ExportErrorBody {
  attachments?: number
  max?: number
  message?: string | string[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportDSAttendances',
  props: {
    isOpen: { type: Boolean },
    mode: { default: 'records' },
    canExportAttachments: { type: Boolean, default: false },
    canExportRecords: { type: Boolean, default: true },
    activeFilters: {},
    queueFilters: {}
  },
  emits: ["update:isOpen"],
  setup(__props: any, { emit }) {

const props = __props;





const { notifyError, notifyErrorMessage } = useErrorToast()
const calendarIcon = mdiCalendarBlankOutline
const filterIcon = mdiFilterOutline

const EXPORT_FORMAT = { ZIP: 'zip', PDF: 'pdf' } as const
const DATE_TYPE = {
  REFERENCE_DATE: 'REFERENCE_DATE',
  SUBMIT_DATE: 'SUBMIT_DATE',
  RECORD_DATE: 'RECORD_DATE'
} as const

/** Janela do debounce da estimativa: o usuário troca 3 filtros em sequência. */
const allowedMode = (mode: ExportModalMode): ExportModalMode =>
  mode === 'records' && !props.canExportRecords && props.canExportAttachments ? 'attachments' : mode

/** Aba corrente. Nasce da prop e passa a ser governada pela barra de abas. */
const selectedMode = ref<ExportModalMode>(allowedMode(props.mode))

const isAttachmentsMode = computed(() => selectedMode.value === 'attachments')

/**
 * "Anexos" é sempre Registro de Atividade: a rota força `kind = ATIVIDADE` no
 * servidor. O rótulo diz isso para o rótulo curto não sugerir "anexo de folha".
 */
const tabItems = computed<TabItem[]>(() => {
  const tabs: TabItem[] = []
  if (props.canExportRecords) {
    tabs.push({ label: 'Registros de plantão', value: 'records', testId: 'export-tab-records' })
  }
  if (props.canExportAttachments) {
    tabs.push({
      label: 'Registro de Atividade',
      value: 'attachments',
      testId: 'export-tab-attachments'
    })
  }
  return tabs
})

const isLoadingBtn = ref(false)
const exportFormat = ref<string>(EXPORT_FORMAT.ZIP)
const dateType = ref<(typeof DATE_TYPE)[keyof typeof DATE_TYPE] | null>(null)
const startDate = ref<Date | null>(null)
const endDate = ref<Date | null>(null)

/** Com as abas à vista, um título por modo seria a mesma informação duas vezes. */
const RECORD_FORMAT_OPTIONS = [
  {
    label: 'Arquivos separados (.zip)',
    description: 'Um arquivo por folha, compactados em .zip',
    value: EXPORT_FORMAT.ZIP as string
  },
  {
    label: 'PDF único compilado',
    description:
      'Todas as folhas do período em um só documento (com página de resumo), na ordem da data do plantão',
    value: EXPORT_FORMAT.PDF as string
  }
]

/**
 * Só `zip` e `xlsx`: o serviço do backend nunca monta PDF de anexo e a DTO
 * recusa qualquer outro valor com 400 (T3/T4). Oferecer o PDF do mockup aqui
 * seria oferecer um erro.
 */
const ATTACHMENT_FORMAT_DESCRIPTIONS: Record<AttachmentExportFormat, string> = {
  zip: 'Um arquivo por anexo, com o guia.csv, compactados em .zip',
  xlsx: 'Só a planilha do guia, sem baixar os anexos'
}

const exportFormatOptions = computed(() =>
  isAttachmentsMode.value
    ? ATTACHMENT_EXPORT_FORMATS.map((value) => ({
        label: ATTACHMENT_EXPORT_FORMAT_LABELS[value],
        description: ATTACHMENT_FORMAT_DESCRIPTIONS[value],
        value: value as string
      }))
    : RECORD_FORMAT_OPTIONS
)

const dateTypeOptions = [
  { label: 'Data do Plantão', value: DATE_TYPE.REFERENCE_DATE },
  { label: 'Data de Envio', value: DATE_TYPE.SUBMIT_DATE },
  { label: 'Data de Criação do Registro', value: DATE_TYPE.RECORD_DATE }
]

// ---------------------------------------------------------------------------
// M3 ④ — partes do nome do arquivo
// ---------------------------------------------------------------------------

/**
 * Valores do preview. São LITERAIS do mockup e espelham os slugs do backend
 * (`EXPORT_LEG_SLUGS`, `ACTIVITY_TYPE_SLUGS`): o preview promete o nome que o
 * arquivo vai ter, não um exemplo genérico.
 *
 * Como são cópias, mudança de slug no backend não chega aqui sozinha — ao
 * mexer naquelas constantes, mexer também nestas e em `NAME_PREVIEW_SUFFIX`.
 */
const NAME_PART_PREVIEW: Record<ExportNamePart, string> = {
  [ExportNamePart.DOCTOR]: 'ana-souza',
  [ExportNamePart.STATION_DATE]: '2026-09-10',
  [ExportNamePart.LEG]: 'check-out',
  [ExportNamePart.ACTIVITY_TYPE]: 'print-app'
}

const createNameParts = () => DEFAULT_EXPORT_NAME_PARTS.map((part) => ({ part, checked: true }))

const nameParts = ref<{ part: ExportNamePart; checked: boolean }[]>(createNameParts())

/** Partes marcadas NA ORDEM da lista — é a ordem que vira o nome do arquivo. */
const selectedNameParts = computed(() =>
  nameParts.value.filter((item) => item.checked).map((item) => item.part)
)

/**
 * Sufixo que o backend acrescenta SEMPRE, depois das partes escolhidas
 * (`buildActivityAttachmentFileName`): `_reg<id do registro>_<índice>`. O
 * preview omitia o `_reg<id>` e prometia um nome que nunca sairia do ZIP — é
 * justamente ele que desempata quando o mesmo médico tem dois plantões no
 * mesmo dia, então não é detalhe que se possa esconder. O `55` é exemplo: o id
 * muda a cada registro, como a data e o nome do médico mudam.
 */
const namePreview = computed(() => {
  const parts = selectedNameParts.value.length ? selectedNameParts.value : DEFAULT_EXPORT_NAME_PARTS
  return `${parts.map((part) => NAME_PART_PREVIEW[part]).join('_')}${NAME_PREVIEW_SUFFIX}`
})

function moveNamePart(index: number, offset: number) {
  const target = index + offset
  if (target < 0 || target >= nameParts.value.length) return
  const list = [...nameParts.value]
  const [moved] = list.splice(index, 1)
  list.splice(target, 0, moved)
  nameParts.value = list
}

const draggedIndex = ref<number | null>(null)

function onDragStart(index: number) {
  draggedIndex.value = index
}

function onDrop(index: number) {
  if (draggedIndex.value === null || draggedIndex.value === index) return
  moveNamePart(draggedIndex.value, index - draggedIndex.value)
  draggedIndex.value = null
}

/** Teclado além do drag: arrastar não é alcançável por quem navega por Tab. */
function onNamePartKeydown(event: KeyboardEvent, index: number) {
  if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return
  event.preventDefault()
  moveNamePart(index, event.key === 'ArrowUp' ? -1 : 1)
}

// ---------------------------------------------------------------------------
// Filtros exibidos
// ---------------------------------------------------------------------------

/**
 * A categoria SAIU daqui: quem responde "por que a folha não veio no zip?" é o
 * rótulo da aba ("Anexos (Registro de Atividade)"). Como chip, no meio de
 * "Filtros aplicados", ela se lia como filtro — e o backend força
 * `kind=ATIVIDADE` no servidor (T4), então nunca foi escolha do usuário.
 *
 * O chip de status fica: "Aprovados (padrão)" é um default que a tela não
 * mostra em nenhum outro lugar.
 */
const readOnlyFilters = computed(() => {
  const filters = [...(props.activeFilters ?? [])]
  if (!isAttachmentsMode.value) return filters
  return [
    ...(props.queueFilters.status?.length
      ? []
      : [{ label: 'Status', value: 'Aprovados (padrão)' }]),
    ...filters
  ]
})

// ---------------------------------------------------------------------------
// Recorte da fila (`queueFilters`) — helpers puros em `exportDsAttendances.utils.ts`
// ---------------------------------------------------------------------------

const blockedHint = computed(() =>
  resolveBlockReason(props.queueFilters, selectedMode.value, props.canExportAttachments)
)

/**
 * A fila com "Data do plantão" preenchida abre o modal já com o período: um
 * clique exporta o que a tela mostra. "Data upload" NÃO pré-preenche — é outra
 * data (`SUBMIT_DATE` seria o análogo, mas o par `uploadStartDate`/`uploadEndDate`
 * continua indo como filtro próprio, e duplicá-lo no período recortaria duas vezes).
 * Datas `yyyy-MM-dd` passam por `parseLocalDate` para não perder um dia no fuso.
 */
function applyQueuePeriod() {
  const queue = props.queueFilters
  if (!queue.startDate && !queue.endDate) return
  dateType.value = DATE_TYPE.REFERENCE_DATE
  startDate.value = parseLocalDate(queue.startDate)
  endDate.value = parseLocalDate(queue.endDate)
}

// ---------------------------------------------------------------------------
// Estimativa
// ---------------------------------------------------------------------------

const estimate = ref<DSAttendanceAttachmentExportEstimate | null>(null)
const isEstimating = ref(false)
const exportError = ref<string | null>(null)
let estimateTimer: ReturnType<typeof setTimeout> | null = null
/** Descarta resposta de estimativa que chegou depois de o filtro mudar. */
let estimateRequestId = 0

const hasPeriod = computed(() => !!dateType.value && !!startDate.value && !!endDate.value)

const canExport = computed(() => {
  if (!hasPeriod.value || blockedHint.value) return false
  return !(isAttachmentsMode.value && isEstimating.value)
})

const formattedEstimatedSize = computed(() => {
  const bytes = estimate.value?.estimatedBytes ?? 0
  const megabytes = bytes / (1024 * 1024)
  if (megabytes < 1) return `${Math.max(1, Math.round(bytes / 1024))} KB`
  return `${megabytes >= 10 ? Math.round(megabytes) : megabytes.toFixed(1)} MB`
})

/**
 * F4-FX3 — `file_size_kb = 0` no legado passou a significar "tamanho
 * desconhecido", não "0 byte". `estimateComplete === false` é o sinal do
 * backend; `undefined` (backend antigo) cai no `false` do `===` e mantém o
 * texto de hoje (tolerância a backend sem os campos novos).
 */
const isEstimateIncomplete = computed(() => estimate.value?.estimateComplete === false)

/**
 * Nenhum anexo do recorte tem tamanho medido: `estimatedBytes` não é "quase
 * zero", é NADA — mostrar "~1 KB estimados" aqui seria inventar um número.
 */
const allAttachmentsUnmeasured = computed(() => {
  if (!estimate.value || !isEstimateIncomplete.value) return false
  return (estimate.value.attachmentsWithoutSize ?? 0) >= estimate.value.attachments
})

function cancelPendingEstimate() {
  if (estimateTimer) {
    clearTimeout(estimateTimer)
    estimateTimer = null
  }
}

async function runEstimate() {
  const requestId = ++estimateRequestId
  isEstimating.value = true
  try {
    const result = await Network.dsAttendance.getAttachmentExportEstimate(buildAttachmentParams())
    if (requestId !== estimateRequestId) return
    estimate.value = result
  } catch (e: unknown) {
    if (requestId !== estimateRequestId) return
    // A estimativa é conforto. O 403 do D-0, porém, precisa aparecer ANTES de o
    // usuário montar o recorte inteiro e clicar em Exportar.
    estimate.value = null
    exportError.value = describeExportError(e)
  } finally {
    if (requestId === estimateRequestId) isEstimating.value = false
  }
}

function scheduleEstimate() {
  if (!isAttachmentsMode.value) return
  cancelPendingEstimate()
  // I7 — a sequência avança AQUI, não só dentro de `runEstimate`. Sem isto, uma
  // request já em voo continuava válida enquanto o timer da nova esperava: por
  // ~300 ms a tela mostrava "213 anexos" de um recorte que não é mais o da tela,
  // com o botão Exportar habilitado.
  estimateRequestId += 1
  estimate.value = null
  if (!hasPeriod.value) {
    isEstimating.value = false
    return
  }
  isEstimating.value = true
  estimateTimer = setTimeout(() => {
    estimateTimer = null
    void runEstimate()
  }, ESTIMATE_DEBOUNCE_MS)
}

/**
 * Minor — chave por VALOR, não por referência. O pai recria o objeto da fila a
 * cada render (`Index.vue`), então um watch `deep` sobre a prop refazia a
 * estimativa em qualquer re-render da fila e **apagava** a mensagem de
 * `EXPORT_TOO_LARGE`/403 que o usuário precisava ler.
 */
const filterKey = computed(() => JSON.stringify(props.queueFilters))

watch([dateType, startDate, endDate, filterKey], () => {
  exportError.value = null
  scheduleEstimate()
})

/** A prop só decide a aba de entrada; depois disso quem manda é a barra. */
watch(
  () => props.mode,
  (mode) => {
    selectedMode.value = allowedMode(mode)
  }
)

/**
 * I6 — trocar de aba NÃO pode carregar o formato junto: escolher "PDF único
 * compilado" em registros e passar para anexos mandava `format=pdf` numa rota
 * que responde 400 pelo `@IsIn([zip,xlsx])`; o caminho inverso (`xlsx` batendo
 * em `exportContainers`) é igualmente real. `zip` é válido nos dois lados, então
 * serve de ponto neutro.
 *
 * O que NÃO se reseta aqui é deliberado: período e tipo de data valem para as
 * duas rotas (os filtros de recorte são idênticos), e aba é justamente o
 * controle que promete ao usuário encontrar o que preencheu ao voltar. Antes
 * das abas isto era um `resetForm()` inteiro — que como troca de modo era
 * invisível, mas como troca de aba seria perda de trabalho. O reset total
 * continua no fechamento do modal, onde faz sentido.
 */
watch(selectedMode, () => {
  exportFormat.value = EXPORT_FORMAT.ZIP
  nameParts.value = createNameParts()
  exportError.value = null
  estimate.value = null
  scheduleEstimate()
})

/**
 * Abrir pré-preenche o período com o da fila (`immediate`: a fila pode montar o
 * modal já aberto). Só na ABERTURA, de propósito: a fila recria `queueFilters` a
 * cada render, e reaplicar a cada mudança apagaria o período que o usuário
 * acabou de editar. Fechar limpa tudo (watch abaixo) — reabrir com outra fila
 * re-preenche.
 */
watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) applyQueuePeriod()
  },
  { immediate: true }
)

/**
 * Minor — o modal nunca desmonta (`v-model:is-open`), então fechar dentro dos
 * 400 ms do debounce disparava um `GET .../estimate` inútil e deixava um 403
 * dele preenchido para a próxima abertura.
 */
watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) return
    cancelPendingEstimate()
    estimateRequestId += 1
    isEstimating.value = false
    resetForm()
  }
)

onBeforeUnmount(cancelPendingEstimate)

// ---------------------------------------------------------------------------
// Exportação
// ---------------------------------------------------------------------------

function closeModal() {
  emit('update:isOpen', false)
  // O watch de `isOpen` também limpa, mas o pai pode ignorar o emit (v-model
  // manual): o formulário nunca pode sobreviver a um "Cancelar".
  cancelPendingEstimate()
  estimateRequestId += 1
  isEstimating.value = false
  resetForm()
}

function resetForm() {
  // Volta à aba de entrada: sem isto, quem fecha o modal dentro de "Anexos" o
  // reabriria ali, já que o pai passa sempre `records` e o watch de `mode` só
  // dispara quando o valor muda.
  selectedMode.value = allowedMode(props.mode)
  // ZIP é válido nos DOIS modos (`records` e `attachments`), então serve de
  // default sem vazar formato de um modo para o outro.
  exportFormat.value = EXPORT_FORMAT.ZIP
  dateType.value = null
  startDate.value = null
  endDate.value = null
  nameParts.value = createNameParts()
  estimate.value = null
  exportError.value = null
}

function buildExportParams(): DSAttendanceExportContainersParams {
  if (!dateType.value || !startDate.value || !endDate.value) {
    throw new Error('Parâmetros obrigatórios não foram preenchidos')
  }
  return {
    ...toExportCut(props.queueFilters),
    dateType: dateType.value,
    // O período é SEMPRE o do formulário: o da fila só serviu de pré-preenchimento.
    startDate: format(startDate.value, 'yyyy-MM-dd'),
    endDate: format(endDate.value, 'yyyy-MM-dd')
  }
}

/**
 * Estimativa e download montam o MESMO recorte. Divergir aqui faria a tela
 * prometer "213 anexos" e entregar outro número — a razão de o backend (T3)
 * ter uma função única de filtros.
 *
 * `kind` e `withSummaryPage` saem EXPLICITAMENTE, e não só pelo tipo: o `Omit`
 * não impede um spread de carregá-los, e a fila na aba "Atividade" chega com
 * `kind` preenchido. O service já se blinda; aqui o parâmetro nasce limpo.
 */
function buildAttachmentParams(): DSAttendanceAttachmentExportParams {
  const params: DSAttendanceExportContainersParams & DSAttendanceAttachmentExportParams = {
    ...buildExportParams(),
    nameBy: selectedNameParts.value
  }
  delete params.kind
  delete params.withSummaryPage
  return params
}

function triggerFileDownload(data: BlobPart, headers: Record<string, string>) {
  const disposition = headers?.['content-disposition'] as string | undefined
  const fallbackName = isAttachmentsMode.value ? 'anexos' : 'registros'
  const fileName =
    disposition?.split('filename=')[1]?.replace(/"/g, '') ?? `${fallbackName}.${exportFormat.value}`
  const blob = data instanceof Blob ? data : new Blob([data])
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

function exportErrorBody(e: unknown): ExportErrorBody {
  const source = unwrapApiError(e) as { response?: { data?: ExportErrorBody } } | null | undefined
  return source?.response?.data ?? {}
}

/**
 * Mensagens do modo anexos. As duas que importam:
 * - `EXPORT_TOO_LARGE`: sem os números o usuário não sabe quanto reduzir;
 * - 403: no D-0 só o Administrador Geral tem `attendance_extracting` (T4), então
 *   o 403 é o caminho esperado — dizer "erro" faria o suporte abrir incidente.
 */
function describeExportError(e: unknown): string {
  if (hasApiErrorCode(e, EXPORT_TOO_LARGE)) {
    const { attachments, max } = exportErrorBody(e)
    return `O recorte tem ${attachments ?? 'mais'} anexos e o limite por exportação é ${
      max ?? 'menor'
    }. Estreite o período ou filtre por unidade/escala e tente de novo.`
  }

  const status = getApiErrorStatus(e)
  if (status === 403) {
    return 'Você não tem permissão para extrair anexos. Peça ao Administrador Geral o perfil de extração (Extrator) para esta empresa ou escala.'
  }
  if (status === 404) {
    return 'Nenhum anexo encontrado com os filtros informados.'
  }
  // 5xx nunca chega ao usuário: texto de exceção interna não é acionável e pode
  // vazar detalhe de implementação. O corte existia no caminho `string` e
  // precisa valer também para o fallback normalizado.
  if (status && status >= 500) return DEFAULT_ATTACHMENT_ERROR_MESSAGE

  const { message } = exportErrorBody(e)
  if (typeof message === 'string' && message) return message
  // I9 — os erros de validação do Nest chegam como `string[]`; o `typeof` os
  // jogava fora e todo 400 que não fosse `EXPORT_TOO_LARGE` virava "Tente
  // novamente". `getApiErrorMessage` já normalizou a mensagem em `ServiceError`.
  return getApiErrorMessage(e, DEFAULT_ATTACHMENT_ERROR_MESSAGE)
}

/**
 * O funil caseiro anterior (guard `isApiError` + cadeia de status) nunca via o body do
 * erro: o endpoint responde `blob`, então a explicação do backend chegava dentro de um
 * Blob e caía sempre no texto padrão. Com o unwrap no service, `notifyError` já entrega
 * a mensagem certa — sobra aqui só o 404, cujo corpo não diz nada de útil ao usuário.
 */
function handleExportError(e: unknown) {
  if (isAttachmentsMode.value) {
    // No modo anexos a mensagem fica NO modal: o usuário precisa dela para
    // ajustar o recorte que está na tela, e o toast some antes disso.
    exportError.value = describeExportError(e)
    return
  }
  if (getApiErrorStatus(e) === 404) {
    notifyErrorMessage('Nenhum registro encontrado com os filtros informados.')
    return
  }
  notifyError(e, DEFAULT_ERROR_MESSAGE)
}

async function exportRecords() {
  const params = buildExportParams()
  // Solicitar página de resumo quando formato é PDF
  if (exportFormat.value === EXPORT_FORMAT.PDF) {
    params.withSummaryPage = true
  }
  return Network.dsAttendance.exportContainers(
    params,
    exportFormat.value as (typeof EXPORT_FORMAT)[keyof typeof EXPORT_FORMAT]
  )
}

async function exportAttachments() {
  return Network.dsAttendance.exportAttachments(
    buildAttachmentParams(),
    exportFormat.value as AttachmentExportFormat
  )
}

async function handleExport() {
  if (!canExport.value) return

  isLoadingBtn.value = true
  exportError.value = null
  try {
    const response = isAttachmentsMode.value ? await exportAttachments() : await exportRecords()
    triggerFileDownload(response.data, response.headers)
    closeModal()
    resetForm()
  } catch (e: unknown) {
    handleExportError(e)
  } finally {
    isLoadingBtn.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.isOpen,
    onClose: _cache[6] || (_cache[6] = ($event: any) => (!isLoadingBtn.value && closeModal())),
    maxWidth: "max-w-[600px]",
    "has-header-border": "",
    "has-footer-border": "",
    class: "export-plantao-modal"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left m-0 p-0" }, _toDisplayString(modalTitle))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_34, [
        _createVNode(OutlinedButton, {
          "data-testid": "export-cancel-button",
          text: "Cancelar",
          width: "120px",
          height: "48px",
          onClick: closeModal,
          disabled: isLoadingBtn.value,
          class: "!border-primary30 !text-primary30 !font-bold"
        }, null, 8, ["disabled"]),
        _createVNode(FilledButton, {
          "data-testid": "export-submit-button",
          text: "Exportar",
          width: "120px",
          height: "48px",
          onClick: handleExport,
          loading: isLoadingBtn.value,
          disabled: !canExport.value,
          class: "!bg-primary30 !text-white !font-bold"
        }, null, 8, ["loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      (tabItems.value.length > 1)
        ? (_openBlock(), _createBlock(Tabs, {
            key: 0,
            modelValue: selectedMode.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMode).value = $event)),
            tabs: tabItems.value,
            "data-testid": "export-tabs"
          }, null, 8, ["modelValue", "tabs"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("fieldset", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exportFormatOptions.value, (opt) => {
              return (_openBlock(), _createElementBlock("label", {
                key: opt.value,
                "data-testid": `export-format-${opt.value}-button`,
                class: _normalizeClass(["format-card", { 'format-card--active': exportFormat.value === opt.value }])
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((exportFormat).value = $event)),
                  type: "radio",
                  value: opt.value,
                  class: "format-card__radio-input"
                }, null, 8, _hoisted_6), [
                  [_vModelRadio, exportFormat.value]
                ]),
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(opt.label), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(opt.description), 1)
                ])
              ], 10, _hoisted_5))
            }), 128))
          ])
        ]),
        (isAttachmentsMode.value)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nameParts.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.part,
                    "data-testid": `export-name-part-${item.part}`,
                    class: "name-part",
                    draggable: "true",
                    tabindex: "0",
                    onDragstart: ($event: any) => (onDragStart(index)),
                    onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    onDrop: _withModifiers(($event: any) => (onDrop(index)), ["prevent"]),
                    onKeydown: ($event: any) => (onNamePartKeydown($event, index))
                  }, [
                    _createElementVNode("label", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                        type: "checkbox",
                        class: "accent-[#2F7F91]"
                      }, null, 8, _hoisted_17), [
                        [_vModelCheckbox, item.checked]
                      ]),
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(EXPORT_NAME_PART_LABELS)[item.part]), 1)
                    ]),
                    _createElementVNode("span", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        "data-testid": `export-name-part-${item.part}-up`,
                        class: _normalizeClass(["name-part__move", { 'opacity-40': index === 0 }]),
                        "aria-disabled": index === 0,
                        "aria-label": `Mover ${_unref(EXPORT_NAME_PART_LABELS)[item.part]} para cima`,
                        onClick: ($event: any) => (moveNamePart(index, -1))
                      }, " ↑ ", 10, _hoisted_20),
                      _createElementVNode("button", {
                        type: "button",
                        "data-testid": `export-name-part-${item.part}-down`,
                        class: _normalizeClass(["name-part__move", { 'opacity-40': index === nameParts.value.length - 1 }]),
                        "aria-disabled": index === nameParts.value.length - 1,
                        "aria-label": `Mover ${_unref(EXPORT_NAME_PART_LABELS)[item.part]} para baixo`,
                        onClick: ($event: any) => (moveNamePart(index, 1))
                      }, " ↓ ", 10, _hoisted_21)
                    ])
                  ], 40, _hoisted_15))
                }), 128))
              ]),
              _createElementVNode("p", _hoisted_22, _toDisplayString(namePreview.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_v_icon, { icon: _unref(filterIcon) }, null, 8, ["icon"]),
            _hoisted_24
          ]),
          (readOnlyFilters.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(readOnlyFilters.value, (filter) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: filter.label + filter.value,
                    "data-testid": "export-filter-chip",
                    role: "listitem",
                    class: "px-3 py-2 text-sm border border-[#2F7F91] text-[#2F7F91] rounded-full font-bold bg-teal-50/30"
                  }, [
                    _createTextVNode(_toDisplayString(filter.label) + ": ", 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(filter.value), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_27, "Nenhum filtro adicional aplicado.")),
          _hoisted_28
        ]),
        (blockedHint.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(blockedHint.value), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_v_select, {
          modelValue: dateType.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateType).value = $event)),
          "data-testid": "export-dateType-select",
          label: "Tipo de data *",
          items: dateTypeOptions,
          "item-title": "label",
          "item-value": "value",
          variant: "outlined",
          density: "comfortable",
          "hide-details": "",
          color: "primary30",
          class: "text-[#323232]"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_unref(DatePicker), {
            modelValue: startDate.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((startDate).value = $event)),
            locale: "pt-BR",
            masks: { input: 'DD/MM/YYYY' },
            popover: { positionFixed: true } as Record<string, boolean>
          }, {
            default: _withCtx(({ inputValue, inputEvents }) => [
              _createVNode(_component_v_text_field, _mergeProps({
                "data-testid": "export-startDate-picker",
                label: "Data início *",
                "append-inner-icon": _unref(calendarIcon),
                "model-value": inputValue
              }, _toHandlers(inputEvents), {
                variant: "outlined",
                density: "comfortable",
                "hide-details": "",
                readonly: "",
                color: "primary30",
                class: "w-full bg-white text-[#323232]"
              }), null, 16, ["append-inner-icon", "model-value"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_unref(DatePicker), {
            modelValue: endDate.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((endDate).value = $event)),
            locale: "pt-BR",
            masks: { input: 'DD/MM/YYYY' },
            popover: { positionFixed: true } as Record<string, boolean>
          }, {
            default: _withCtx(({ inputValue, inputEvents }) => [
              _createVNode(_component_v_text_field, _mergeProps({
                "data-testid": "export-endDate-picker",
                label: "Data fim *",
                "append-inner-icon": _unref(calendarIcon),
                "model-value": inputValue
              }, _toHandlers(inputEvents), {
                variant: "outlined",
                density: "comfortable",
                "hide-details": "",
                readonly: "",
                color: "primary30",
                class: "w-full bg-white text-[#323232]"
              }), null, 16, ["append-inner-icon", "model-value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (isAttachmentsMode.value && isEstimating.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, " Calculando o tamanho da exportação… "))
          : (isAttachmentsMode.value && estimate.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                (allAttachmentsUnmeasured.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(estimate.value.containers) + " registros · ", 1),
                      _createElementVNode("b", null, _toDisplayString(estimate.value.attachments) + " anexos", 1),
                      _createTextVNode(" · tamanho não estimado (" + _toDisplayString(estimate.value.attachmentsWithoutSize) + " anexos do legado) ", 1)
                    ], 64))
                  : (isEstimateIncomplete.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(estimate.value.containers) + " registros · ", 1),
                        _createElementVNode("b", null, _toDisplayString(estimate.value.attachments) + " anexos", 1),
                        _createTextVNode(" · ≈" + _toDisplayString(formattedEstimatedSize.value) + " medidos + " + _toDisplayString(estimate.value.attachmentsWithoutSize) + " anexos sem tamanho conhecido (legado) ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(estimate.value.containers) + " registros · ", 1),
                        _createElementVNode("b", null, _toDisplayString(estimate.value.attachments) + " anexos", 1),
                        _createTextVNode(" · ~" + _toDisplayString(formattedEstimatedSize.value) + " estimados ", 1)
                      ], 64))
              ]))
            : _createCommentVNode("", true),
        (isAttachmentsMode.value && exportError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(exportError.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})